import { createContext, useContext, useMemo, useState } from "react";

// Bidirectional cross-highlight between the list and the map.
// Cards call setHoveredId(id) on enter, setHoveredId(null) on leave.
// Markers do the same. Each component renders a highlight when
// hoveredId === its own id. NO scroll logic — by design (see DECISIONS.md D7).

const SearchHoverContext = createContext({
    hoveredId: null,
    setHoveredId: () => {},
});

export const SearchHoverProvider = ({ children }) => {
    const [hoveredId, setHoveredId] = useState(null);
    const value = useMemo(() => ({ hoveredId, setHoveredId }), [hoveredId]);
    return <SearchHoverContext.Provider value={value}>{children}</SearchHoverContext.Provider>;
};

export const useSearchHover = () => useContext(SearchHoverContext);

export default SearchHoverContext;

// This file lives under src/pages/ for historical reasons but is a shared
// module, not a route. Next.js still registers it as a page; serve 404 for
// its accidental URL instead of prerendering it (which crashes the build now
// that the app really renders during SSR).
export function getStaticProps() {
    return { notFound: true };
}
